import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'
import './index.css'

interface ButtonGreyProps {
  buttonText?: string;
  loading?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  onClick?: () => void;
  holderStyles?: React.CSSProperties;
  buttonStyles?: React.CSSProperties;
  buttonHolderId?: string;
  disabled?: boolean;
  to?: string | false;
  icon?: React.ReactNode;
  title?: string;
}

const ButtonGrey: React.FC<ButtonGreyProps> = ({
  buttonText = 'Submit',
  loading = false,
  htmlType = 'submit',
  onClick = () => {},
  holderStyles = {},
  buttonStyles = {},
  buttonHolderId = '',
  disabled = false,
  to = false,
  icon = '',
  title = '',
}) => {
  return (
    <div id={buttonHolderId} style={holderStyles} className="button-holder-grey">
      {to && (
        <Link to={to}>
          {' '}
          <Button
            style={buttonStyles}
            type="primary"
            htmlType={htmlType}
            onClick={onClick}
            loading={loading}
            disabled={disabled}
            className={buttonText === 'Skip' ? 'skipButton' : ''}
            title={title}
          >
            <span>{buttonText}</span>
          </Button>
        </Link>
      )}
      {!to && (
        <Button
          style={buttonStyles}
          type="primary"
          htmlType={htmlType}
          onClick={onClick}
          loading={loading}
          disabled={disabled}
          className={buttonText === 'Skip' ? 'skipButton' : ''}
          icon={icon}
          title={title}
        >
          <span>{buttonText}</span>
        </Button>
      )}
    </div>
  )
}

export default ButtonGrey
